import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m17 2 4 4-4 4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 11v-1a4 4 0 0 1 4-4h14", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m7 22-4-4 4-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 13v1a4 4 0 0 1-4 4H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M11 10h1v4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Repeat1";
const Repeat1 = memo(themed(Icon));
export {
  Repeat1
};
//# sourceMappingURL=repeat-1.js.map
